import React from 'react';
import { ItemScheme } from '../../../../../../Components/Form/MagicFormItem';
import MagicForm from '../../../../../../Components/Form/MagicForm';
import { MagicField } from '../../../../../../Enums/MagicField.enum';

export interface LaboratoryActivationResultsDistributionValues {
	distribution: string;
}

interface Props {
	onSuccess: (values: LaboratoryActivationResultsDistributionValues) => void;
}

const formScheme: ItemScheme[] = [
	{
		type: MagicField.RADIOLIST,
		key: 'distribution',
		children: [
			{
				value: 'electronicToMD',
				title:
					'component.laboratoryActivationResultsDistribution.electronicToMD',
			},
			{
				value: 'byPost',
				title: 'component.laboratoryActivationResultsDistribution.byPost',
			},
			{
				value: 'combined',
				title: 'component.laboratoryActivationResultsDistribution.combined',
			},
		],
		settings: {
			required: true,
		},
	},
];

const LaboratoryActivationResultsDistribution: React.FC<Props> = ({
	onSuccess,
}) => {
	const handleSubmit = (
		values: LaboratoryActivationResultsDistributionValues,
	) => {
		onSuccess(values);
	};

	return (
		<MagicForm
			formScheme={formScheme}
			onSubmit={handleSubmit}
			submitText='base.shared.continue'
		/>
	);
};

export default LaboratoryActivationResultsDistribution;
